
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/upload-property-documents",
      function () {
        return require("private-next-pages/features/upload-property-documents.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/upload-property-documents"])
      });
    }
  